import { defineStore } from 'pinia'
import api from '../api'
import { getCurrentUser } from '../api/auth'

export const useAuthStore = defineStore('auth', {
  state: () => ({
    token: localStorage.getItem('token') || null,
    user: JSON.parse(localStorage.getItem('user') || 'null'),
    isAuthenticated: false
  }),
  
  getters: {
    isLoggedIn: (state) => !!state.token && !!state.user,
    currentUser: (state) => state.user
  },
  
  actions: {
    setAuth(token, user) {
      this.token = token
      this.user = user
      this.isAuthenticated = true
      
      // Сохраняем в localStorage
      localStorage.setItem('token', token)
      localStorage.setItem('user', JSON.stringify(user))
      
      // Устанавливаем токен в заголовки API
      api.defaults.headers.common['Authorization'] = `Bearer ${token}`
    },
    
    logout() {
      this.token = null
      this.user = null
      this.isAuthenticated = false
      
      // Удаляем из localStorage
      localStorage.removeItem('token')
      localStorage.removeItem('user')
      
      // Удаляем токен из заголовков API
      delete api.defaults.headers.common['Authorization']
    },
    
    initializeAuth() {
      if (this.token) {
        api.defaults.headers.common['Authorization'] = `Bearer ${this.token}`
        this.isAuthenticated = true
      }
    },
    
    async checkAuth() {
      if (!this.token) return false
      
      try {
        const response = await getCurrentUser()
        this.user = response.data
        this.isAuthenticated = true
        return true
      } catch (error) {
        console.error('Auth check failed:', error)
        this.logout()
        return false
      }
    }
  }
})
